/* eslint-disable @next/next/no-sync-scripts */ import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "48",
        height: "36",
        viewBox: "0 0 48 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("script", {
                type: "text/javascript",
                src: "chrome-extension://fnjhmkhhmkbjkkabndcnnogagogbneec/in-page.js"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.8266 5.74803C17.6544 -1.91601 30.3457 -1.91601 38.1735 5.74803L39.1155 6.67041C39.5069 7.05361 39.5069 7.6749 39.1155 8.05811L35.8929 11.2134C35.6972 11.405 35.3799 11.405 35.1842 11.2134L33.8878 9.94408C28.4269 4.59745 19.5731 4.59745 14.1123 9.94408L12.7239 11.3034C12.5282 11.495 12.2109 11.495 12.0153 11.3034L8.79257 8.14812C8.40118 7.76492 8.40118 7.14363 8.79257 6.76042L9.8266 5.74803ZM44.8383 12.2735L47.7065 15.0817C48.0978 15.4649 48.0978 16.0862 47.7065 16.4694L34.7736 29.1319C34.3822 29.5152 33.7476 29.5152 33.3562 29.132C33.3562 29.132 33.3562 29.132 33.3562 29.132L24.1773 20.145C24.0794 20.0492 23.9208 20.0492 23.8229 20.145L23.8229 20.145L14.6441 29.1319C14.2528 29.5152 13.6182 29.5152 13.2268 29.132C13.2268 29.132 13.2268 29.132 13.2268 29.132L0.293541 16.4692C-0.0978471 16.086 -0.0978471 15.4647 0.293541 15.0815L3.16174 12.2733C3.55313 11.8901 4.1877 11.8901 4.57908 12.2733L13.7582 21.2604C13.856 21.3562 14.0147 21.3562 14.1125 21.2604C14.1125 21.2604 14.1125 21.2604 14.1125 21.2604L23.2912 12.2733C23.6826 11.8901 24.3171 11.8901 24.7085 12.2733C24.7085 12.2733 24.7085 12.2733 24.7085 12.2733L33.8876 21.2604C33.9855 21.3562 34.1441 21.3562 34.242 21.2604L43.4209 12.2735C43.8123 11.8903 44.4469 11.8903 44.8383 12.2735Z",
                fill: "#3B99FC"
            })
        ]
    }));
};
export default Icon;
